import { MapTo } from '@adobe/aem-react-editable-components';
import { Component } from 'react';
import {isAEMAuthor, isMobileApp, isInternal, getApiKeyFIS} from '../../utils/api';
import fisConfig from '../../utils/url-directory';

class XFScriptsFragment extends Component {
  componentDidMount() {

    const w = window;
      let fisExtApiHost = fisConfig.PROD.EXTERNAL.fisapi;
      let fisIntApiHost = fisConfig.PROD.INTERNAL.fisapi;

      let awsEnvironmentDomain: string ;

      // internal flow
      if(window.location.hostname.indexOf('awstrp.net') > -1 || window.location.hostname.indexOf('fisretirement.net') > -1  ){
          if (window.location.hostname.indexOf('rpsdev') > -1 || window.location.hostname.indexOf('dev') > -1 || window.location.hostname.indexOf('localhost') > -1 ) {
              fisIntApiHost = fisConfig.DEV.INTERNAL.fisapi;
          } else if (window.location.hostname.indexOf('sit') > -1 || window.location.hostname.indexOf('stage') > -1 || window.location.hostname.indexOf('rpsstg') > -1) {
              fisIntApiHost = fisConfig.STAGE.INTERNAL.fisapi;
          }
          awsEnvironmentDomain = fisIntApiHost;
      } else {
          // external flow
          if (window.location.hostname.indexOf('rpsdev') > -1 || window.location.hostname.indexOf('dev') > -1 || window.location.hostname.indexOf('localhost') > -1) {
              fisExtApiHost = fisConfig.DEV.EXTERNAL.fisapi;
          } else if (window.location.hostname.indexOf('sit') > -1 || window.location.hostname.indexOf('stage') > -1 || window.location.hostname.indexOf('rpsstg') > -1) {
              fisExtApiHost =  fisConfig.STAGE.EXTERNAL.fisapi;
          }
          awsEnvironmentDomain = fisExtApiHost;
      }
    if (!isAEMAuthor() && !isMobileApp()) {
      w.GlobalNav.initialize();
      w.SiteBar.initialize();
      w.TopNav.initialize();
      w.MMRMessage.initialize();
      w.updateProspectusLink();
      w.InboxPopup.initialize();
      w.ProfilePopup.initialize();
      if (isInternal()) {
        w.runAuthentication();
      }
      w.WorkplaceCommon.makeServiceCall({
        url: awsEnvironmentDomain + '/rps/workplace/navigation/footer',
        type: 'GET',
         headers: {
                Accept: '*/*',
                'X-TRP-Requested-With': 'XMLHttpRequest',
                'trp-request-consumer-initial':'workplace-profile',
                'apiKey': getApiKeyFIS()
            },
      }).then(function(data) {
        if (data.err) {
          return;
        }
        if (data.hasTradelinkAccount === false) {
          document.querySelector('#trade-link-legal')?.classList.add('hide');
          document.querySelector('#trade-link-legal div')?.classList.add('hide');
        }
        if (data.hasSelfDirectedAccount === false) {
          document.querySelector('#self-directed-account')?.classList.add('hide');
          document.querySelector('#self-directed-account div')?.classList.add('hide');
        }
      });
      w.TopNav.addNavigationEventListeners();
    }
  }

  render() {
    return true;
  }
}

export default MapTo('workplace-profile/components/xfscriptscontainer')(XFScriptsFragment);
